import { fromJS } from 'immutable';

import { TypedMap } from 'Utils/immutable-types';
import { wrapImmutableReducerInPojoTranslation } from 'Utils/reducers';

import { MTM_SUBMIT_FEEDBACK } from './constants';

export interface MomentPageReducerState {
  feedbackSubmitted: boolean;
}

export type MomentState = TypedMap<MomentPageReducerState>;

const initialState: MomentState = fromJS({
  feedbackSubmitted: false,
});

function momentPageReducer(
  state = initialState,
  action: {
    type: any;
  },
) {
  switch (action.type) {
    case MTM_SUBMIT_FEEDBACK:
      return submitMtmFeedback(state);
    default:
      return state;
  }
}

function submitMtmFeedback(state: MomentState) {
  return state.set('feedbackSubmitted', true);
}

const pojoMomentPageReducer = wrapImmutableReducerInPojoTranslation(momentPageReducer);

export default pojoMomentPageReducer;
